module.exports = __webpack_public_path__ + "img/support_b7.bf653fd5.png";